import { ReactElement } from 'react'

import { Button } from 'antd'

import { ConditionalWrapper } from 'components/ConditionalWrapper'
import { ToolTip } from 'components/ToolTip'

import { type IconButtonProps } from './localTypes'
import * as styles from './styles.module.scss'

const IconButton = ({
    tooltipPlacement = 'top',
    tooltipTitle,
    ...btnProps
}: IconButtonProps): ReactElement => {
    const hasTooltip = Boolean(tooltipTitle)

    const button = (
        <Button
            shape="circle"
            aria-label={
                typeof tooltipTitle === 'string' ? tooltipTitle : undefined
            }
            {...btnProps}
        />
    )

    return (
        <ConditionalWrapper
            condition={hasTooltip}
            wrapper={(children) => (
                <ToolTip
                    title={tooltipTitle}
                    arrow={{ pointAtCenter: true }}
                    placement={tooltipPlacement}
                >
                    {children}
                </ToolTip>
            )}
        >
            {/* Browsers swallow mouse events on a disabled button, so the
                tooltip needs a hoverable element of its own. */}
            {hasTooltip && btnProps.disabled ? (
                <span className={styles.disabledWrapper}>{button}</span>
            ) : (
                button
            )}
        </ConditionalWrapper>
    )
}

export default IconButton
